export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10364.33b9cc5e.jpg";